// ---------------------------------------------------------
// Datei: MapsButtons.tsx
// Zweck: Wiederverwendbares Button-Paar "Apple Maps"/"Google Maps" für eine Adresse — versucht
//        zuerst die native App zu öffnen, fällt nach kurzer Verzögerung auf die Web-Variante
//        zurück (siehe utils/address.ts). Wird sowohl in der Projektphasen-Kopfzeile
//        (PhasePickerScreen) als auch im Projektvorbereitung-Briefing genutzt — Styling ist
//        dadurch bewusst über className/buttonClassName von außen konfigurierbar statt fest
//        einprogrammiert.
// ---------------------------------------------------------

import React from 'react';
import { openAppleMaps, openGoogleMaps } from '../utils/address';

interface MapsButtonsProps {
  address: string | null | undefined;
  className?: string;
  buttonClassName?: string;
}

const DEFAULT_CONTAINER_CLASS = 'flex items-center gap-2 flex-wrap';
// Button-Optik (Rahmen/Pill), konsistent mit dem bereits bestehenden Apple/Google-Maps-Paar auf
// der Projektphasen-Kopfzeile (PhasePickerScreen) — bewusst kein reiner Text-Link, damit klar
// erkennbar eine Aktion ausgelöst wird (App-Wechsel per Custom-Scheme), nicht nur eine Navigation.
// whitespace-nowrap ist nötig, nicht optional — in schmalen Grid-Spalten (z. B. das
// Kunde-Kachel-Layout im Briefing) würde der Button sonst auf seine Textbreite schrumpfen und
// "Apple"/"Maps" auf zwei Zeilen umbrechen.
const DEFAULT_BUTTON_CLASS =
  'inline-flex items-center rounded-full border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 px-2.5 py-1 text-xs font-semibold text-primary-700 dark:text-primary-300 whitespace-nowrap transition hover:border-primary-400 disabled:opacity-50 disabled:cursor-not-allowed';

const MapsButtons: React.FC<MapsButtonsProps> = ({
  address,
  className = DEFAULT_CONTAINER_CLASS,
  buttonClassName = DEFAULT_BUTTON_CLASS,
}) => {
  const disabled = !address;

  return (
    <div className={className}>
      <button
        type="button"
        onClick={() => address && openAppleMaps(address)}
        disabled={disabled}
        className={buttonClassName}
      >
        Apple Maps
      </button>
      <button
        type="button"
        onClick={() => address && openGoogleMaps(address)}
        disabled={disabled}
        className={buttonClassName}
      >
        Google Maps
      </button>
    </div>
  );
};

export default MapsButtons;
